import { render, staticRenderFns } from "./CompanyResumeDetail.vue?vue&type=template&id=439a5046&scoped=true&"
import script from "../../services/company/company-resume-detail.js?vue&type=script&lang=js&"
export * from "../../services/company/company-resume-detail.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/resume_detail.css?vue&type=style&index=0&id=439a5046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a5046",
  null
  
)

export default component.exports